import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import BoardPage from './pages/BoardPage';
import ChatPage from './pages/ChatPage';
import ListPage from './pages/ListPage';
import LoginPage from './pages/LoginPage';
import NoticePage from './pages/NoticePage';
import HomePage from './pages/HomePage';
import ContentPage from './pages/ContentPage';
import LecturePage from './pages/LecturePage';
import PostPage from './pages/PostPage';




const App = () => {

	const { logged } = useSelector((state) => state.AuthReducer);

	return (
		<Routes>
			<Route path="/" element={<HomePage />} />
			<Route path="/login" element={<LoginPage />} />
			<Route path="/content" element={<ContentPage />} />
			<Route path="/post" element={<PostPage />} />

			<Route
				path="/chat"
				element={logged ? <ChatPage /> : <Navigate to="/" replace />}
			/>

			<Route
				path="/list"
				element={logged ? <ListPage /> : <Navigate to="/" replace />}
			/>

			<Route
				path="/board"
				element={logged ? <BoardPage /> : <Navigate to="/" replace />}
			/>

			<Route
				path="/notice"
				element={logged ? <NoticePage /> : <Navigate to="/" replace />}
			/>

			<Route
				path="/lecture"
				element={logged ? <LecturePage /> : <Navigate to="/" replace />}
			/>

		</Routes>
	);

};


export default App;
